import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { QUERY_KEYS } from 'src/constants'
import { stylesService } from 'src/services'

export const useAccountStyles = () => {
  const { productId, simpleProductId } = useParams()

  const id = simpleProductId || productId

  return useQuery(
    [QUERY_KEYS.GET_ACCOUNT_STYLES, id],
    () => stylesService.getAccountStyles(id),
    {
      keepPreviousData: true,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      enabled: !!id,
    },
  )
}
